export const DRAFT_ENTITY_TYPE_ = "DRAFT_ENTITY_TYPE_";
export const DRAFT_ENTITY_TYPE_USERS = "USER";
export const DRAFT_ENTITY_TYPE_PHOTOS = "PHOTO";
export const DRAFT_ENTITY_TYPE_BOOKS = "BOOK";
export const DRAFT_ENTITY_TYPE_BUSINESS_BOOK_FORUMS = "BUSINESS_BOOK_FORUM";
export const DRAFT_ENTITY_TYPE_SCRAPS = "SCRAP";



